import React from 'react';

import { motion } from 'framer-motion';

import { TabsList, TabsTrigger } from 'components/ui/tabs';

interface IFormSectionsTab {
  value: string;
  label: string;
  disabled?: boolean;
}

interface IFormSectionsTabsProps {
  currentTab: string;
  tabs: IFormSectionsTab[];
}

const FormSectionsTabs: React.FC<IFormSectionsTabsProps> = ({
  currentTab,
  tabs
}) => {
  return (
    <TabsList className="h-auto bg-transparent p-0 justify-start w-full">
      {tabs.map((tab) => (
        <TabsTrigger
          key={tab.value}
          value={tab.value}
          disabled={tab.disabled}
          className="flex-1 flex-col gap-2.5 items-start min-w-[129px] bg-transparent p-0 h-auto data-[state=active]:bg-transparent data-[state=active]:shadow-none relative"
        >
          <motion.span
            animate={{
              color: currentTab === tab.value ? '#4f46e5' : '#a1a1aa'
            }}
            transition={{
              duration: 0.2,
              ease: 'easeInOut'
            }}
            className="font-semibold text-sm leading-5"
          >
            {tab.label}
          </motion.span>
          <div className="h-0.5 rounded-full w-full relative overflow-hidden bg-zinc-400">
            {currentTab === tab.value && (
              <motion.div
                layoutId="activeTabIndicator"
                className="absolute inset-0 bg-indigo-600 rounded-full"
                transition={{
                  duration: 0.3,
                  ease: [0.25, 0.1, 0.25, 1]
                }}
              />
            )}
          </div>
        </TabsTrigger>
      ))}
    </TabsList>
  );
};

export default FormSectionsTabs;
